import { adminPaymentGatewaysConstants } from '_store/_constants';

import alertActionCreators from '../alert.actions';
import service from '../../../services/adminPaymentGateways.service';

const updateChargeStatusGateway = (id, chargeStatusGateway) => {
  return dispatch => {
    dispatch(request(id, chargeStatusGateway));

    service.updateChargeStatusGateway(id, chargeStatusGateway).then(
      response => {
        dispatch(success(response.data));
        dispatch(alertActionCreators.success('Associação atualizada com sucesso!'));
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request(id, chargeStatusGateway) {
    return {
      type: adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_REQUEST,
      payload: { id, chargeStatusGateway },
    };
  }

  function success(chargeStatusGateway) {
    return {
      type: adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_SUCCESS,
      payload: { chargeStatusGateway },
    };
  }

  function failure(error) {
    return {
      type: adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_FAILURE,
      payload: { error },
    };
  }
};

export default updateChargeStatusGateway;
